import { registerPlugin } from '@capacitor/core';

export interface Go7RiderNavigationPlugin {
  openNavigation(options: {
    lat: number;
    lng: number;
    title?: string;
  }): Promise<{ success: boolean }>;
}

export const Go7RiderNavigation = registerPlugin<Go7RiderNavigationPlugin>(
  'Go7RiderNavigation'
);
